import angular from 'angular';
import constants from 'app/constants';
import {
  alerts
} from 'app/components/global';
import {
  amDataService,
  docDataService,
  loaderService,
  orgDataService,
  ssDialogService,
  userService
} from 'app/services';
import controller from './attach-recommendation-document.controller';
import directive from './attach-recommendation-document.directive';


export default angular.module('app.components.advisory.auditTrail.attachRecommendationDocument', [
  alerts,
  amDataService,
  constants,
  docDataService,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
])
  .directive('amAttachRecommendationDocument', directive)
  .controller('AttachRecommendationDocumentController', controller)
  .name;

console.log('app.components.advisory.auditTrail.attachRecommendationDocument created');
